import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orientation: "PORTRAIT",
  totalShutdown: false,
  casinoShutdown: false,
  sportsbookShutdown: false,
  loading: null,
  theme: parseInt(process.env.REACT_APP_THEME || 0)
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    currentOrientation: (state, action) => {
      state.orientation = action.payload;
    },
    updateMaintenanceStatus: (state, action) => {
      state.casinoShutdown =
        action.payload?.casinoShutdown || initialState.casinoShutdown;
      state.totalShutdown =
        action.payload?.totalShutdown || initialState.totalShutdown;
      state.sportsbookShutdown =
        action.payload?.sportsbookShutdown || initialState.sportsbookShutdown;
    },
    getMaintenanceStart: (state, action) => {
      state.loading = true;
    },
    getMaintenanceSuccess: (state, action) => {
      state.loading = false;
      state.casinoShutdown =
        action.payload?.casinoShutdown || initialState.casinoShutdown;
      state.totalShutdown =
        action.payload?.totalShutdown || initialState.totalShutdown;
      state.sportsbookShutdown =
        action.payload?.sportsbookShutdown || initialState.sportsbookShutdown;
    },
    getMaintenanceFailure: (state, action) => {
      state.loading = false;
    },
    setTheme: (state, action) => {
      state.theme = action?.payload;
    }
  }
});

export const {
  currentOrientation,
  updateMaintenanceStatus,
  getMaintenanceStart,
  getMaintenanceSuccess,
  getMaintenanceFailure,
  setTheme
} = settingsSlice.actions;

export default settingsSlice.reducer;
